import React, { useMemo } from 'react';

import Image from '../../components/Image/Image';
import Currency from '../../../helpers/currency';
import { InternalLink } from '../../components/form-elements/Link';
import WiderrufModal from '../../components/Widerruf/WiderrufModal';
import Button from '../../components/form-elements/Button';

const OrderContentReifen = props => {
    const { images, currentOrderState, orderStatusLabel, orderId, product, markenStandort, showWiderrufButton, widerrufInitialValues } = props;

    const shoppingLink = useMemo(() => {
        return markenStandort ? `/${markenStandort.url}/reifen/${product.neutralKey}` : false;
    }, [markenStandort, product.neutralKey]);

    const showShoppingLink = !!shoppingLink;

    return (
        <div className="uk-child-width-1-1" data-uk-grid="">
            <div>
                <div data-uk-grid="">
                    <div className="uk-width-1-1 uk-width-1-6@s">
                        <div className="uk-flex uk-flex-center">
                            <Image src={images[0]} alt="Produktbild" style={{ maxHeight: 200 }} resizeHeight={200} />
                        </div>
                    </div>
                    <div className="uk-width-expand">
                        <h2>
                            <span dangerouslySetInnerHTML={{ __html: product.bezeichnung }} /> {product.serviceTitle}
                        </h2>
                        <div>Artikelnummer: {product.selectedBezugsquelle?.gtin || product.gtin || product.shownId || product.id}</div>
                        {product.orderStatus && (
                            <div>
                                Status: <span className="uk-text-primary">{orderStatusLabel ?? '---'}</span>
                            </div>
                        )}
                        {markenStandort && (
                            <div>
                                Autohaus: <span className="uk-text-primary">{markenStandort.anschrift.firma}</span>,{' '}
                                {markenStandort.anschrift.strasse} {markenStandort.anschrift.plz} {markenStandort.anschrift.ort}
                            </div>
                        )}
                    </div>
                    <div className="uk-width-1-1 uk-width-auto@s uk-flex uk-flex-right">
                        <table className="uk-table uk-table-small">
                            <thead>
                                <tr>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Menge</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Einzelpreis</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Summe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="uk-text-right">
                                    <td>{product.quantity}</td>
                                    <td>
                                        <Currency quantity={product.selectedBezugsquelle.vk_preis} />
                                    </td>
                                    <td className="uk-text-bold">
                                        <Currency quantity={product.selectedBezugsquelle.vk_preis * product.quantity} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {(showShoppingLink || showWiderrufButton) && (
                <div>
                    {showShoppingLink && (
                        <InternalLink modifier="primary" to={shoppingLink}>
                            Erneut kaufen
                        </InternalLink>
                    )}{' '}
                    {showWiderrufButton && (
                        <WiderrufModal initialValues={widerrufInitialValues} variant="account">
                            {({ openModal }) => (
                                <Button modifier="primary" onClick={openModal} ariaHasPopup="dialog">
                                    Vertrag widerrufen
                                </Button>
                            )}
                        </WiderrufModal>
                    )}
                </div>
            )}
        </div>
    );
};

export default OrderContentReifen;
